import { StatusDocument } from 'components/status/status-document';
import { OperationalRequest } from 'store/api/types/documents';
import s from './table.module.scss';

import { useNavigate } from 'react-router-dom';

import { AppRoutes } from 'config/routes';

import Checkbox from 'antd/es/checkbox/Checkbox';
import dayjs from 'dayjs';
import { useGetDocumentStatusesQuery } from 'store/api/documents';
import { useGetMyOrganizationsQuery } from 'store/api/organizations';
import { Organization } from 'store/api/types';
import { DefaultDateFormat } from 'utils/date';

const getColumnStyle = (column: string) => {
  switch (column) {
    case 'deliveryBasis':
    case 'quantity':
    case 'number':
      return { maxWidth: 30, justifyContent: 'center' };
    case 'agreementName':
      return { minWidth: 300, maxHeight: 80, textOverflow: 'ellipsis' };
    case 'statusId':
      return { minWidth: 135 };
    case 'Document.status':
      return { minWidth: 135 };
    case 'supplyAddress':
      return { minWidth: 200, textOverflow: 'ellipsis' };
    default:
      return { minWidth: 100 };
  }
};

export const TableRow = ({
  selectedColumns,
  item,
  onSelectRow,
  selectedRows,
}: {
  onSelectRow: (value: string) => void;
  selectedRows: string[];
  item: any;
  selectedColumns: string[];
}) => {
  const navigate = useNavigate();

  const { data: myOrganizations } = useGetMyOrganizationsQuery();
  const currentOrganization: Organization | undefined = myOrganizations?.[0];

  const { data: statuses } = useGetDocumentStatusesQuery();

  const itemData: any = item.data;

  const { orgOwnerId, id } = item;

  const { statusId } = itemData;

  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get('name');

  const status = statuses?.find((item: any) => item.id === statusId);
  const isOwner = currentOrganization?.id === orgOwnerId;

  const { Home, CustomWidget } = AppRoutes.Dashboard;

  const handleDetailContract = (id: string) => {
    if (statusId === statuses?.find((item) => item?.alias === 'rejected')?.id && isOwner) {
      navigate(
        Home + CustomWidget.Home + CustomWidget.NewRequest + `/${id}` + `/?name=${name}`,
      );
      return;
    }
    if (statusId === statuses?.find((item) => item?.alias === 'approved')?.id && !isOwner) {
      navigate(
        Home + CustomWidget.Home + CustomWidget.RequestApproval + `/${id}` + `/?name=${name}`,
      );
      return;
    }

    navigate(Home + CustomWidget.Home + CustomWidget.NewRequest + `/${id}` + `/?name=${name}`);

    // navigate(
    //   Home + CustomWidget.Home + `/${id}` + CustomWidget.BasicInformation + `?name=${name}`,
    // );
  };

  const handleKeyDown = (id: string, event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleDetailContract(id);
    }
  };

  return (
    <div
      onKeyDown={(e) => handleKeyDown(id, e)}
      onClick={(e) => {
        e.stopPropagation();
        handleDetailContract(id);
      }}
      key={item.id}
      className={s['table-row']}
      role="button"
      tabIndex={0}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Checkbox
          style={{ height: 100, width: 24, paddingLeft: 8 }}
          checked={selectedRows.some((value) => value === item.id)}
          onChange={(e) => {
            console.log('item', item);
            e.stopPropagation();
            onSelectRow(item.id);
          }}
        />
      </div>

      {selectedColumns.map((column: string) => {
        return (
          <TableItem
            key={column}
            content={(itemData as any)[column]}
            data={itemData}
            column={column}
          />
        );
      })}
    </div>
  );
};

export const TableItem = ({
  data,
  content,
  column,
}: {
  data: OperationalRequest;
  content: JSX.Element;
  column: string;
}) => {
  const { data: myOrganizations } = useGetMyOrganizationsQuery();
  const currentOrganization: Organization | undefined = myOrganizations?.[0];

  const { data: statuses } = useGetDocumentStatusesQuery();

  const { statusId, orgOwnerId } = data;

  const status = statuses?.find((item: any) => item.id === statusId);
  const isOwner = currentOrganization?.id === orgOwnerId;

  if (column === 'statusId' || column === 'Document.status') {
    return (
      <div style={getColumnStyle(column)} className={s['table-column']}>
        <StatusDocument text={status?.alias} isOwner={isOwner} />
      </div>
    );
  }

  if (column?.toLocaleLowerCase()?.includes('date')) {
    return (
      <div className={s['table-column']}>
        <span className={s['column-text']}>
          {dayjs((content ?? '')?.toString()).format(DefaultDateFormat)}
        </span>
      </div>
    );
  }

  return (
    <div style={getColumnStyle(column)} className={s['table-column']}>
      <span className={s['column-text']}>{content}</span>
    </div>
  );
};

export const Table = ({
  data,
  selectedColumns,
  onSelectRow,
  headers,
  selectedRows,
}: {
  selectedRows: string[];
  onSelectRow: (value: string) => void;
  selectedColumns: string[];
  headers: any;
  data: any;
}) => {
  return (
    <div className={s['table']}>
      <div className={s['table-header']}>
        {[...selectedColumns].map((item) => (
          <div style={getColumnStyle(item)} key={item} className={s['table-column']}>
            <span className={s['header-text']}>
              {headers.find((header: any) => Object.keys(header)[0] === item)?.[item]}
            </span>
          </div>
        ))}
      </div>

      <div className={s['table-body']}>
        {data?.map((item: any) => (
          <TableRow
            selectedRows={selectedRows}
            onSelectRow={onSelectRow}
            key={item.DocumentNumber?.toString()}
            item={item}
            selectedColumns={selectedColumns}
          />
        ))}
      </div>
    </div>
  );
};
